import { render, staticRenderFns } from "./FieldMenu.vue?vue&type=template&id=5afdeaa8&"
import script from "./FieldMenu.vue?vue&type=script&lang=ts&"
export * from "./FieldMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports